module.exports = __webpack_public_path__ + "img/exp-date-error.1be6eef3.svg";